import React, { Component } from 'react'
import { graphql, compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import {
  GetPatientsById,
  GetAllNotes,
  GetAllNoteTypes,
  CreateComposition,
  UpdateCompositionStatus,
  GetCompositionMetadataById,
  LockNoteForEdit
} from '@sukiai/gql/app'
import {
  SET_AGENT_SIZE,
  SET_AGENT_POSITION,
  SET_MODAL,
  SET_NOTES_LIST,
  GET_SCHEDULE_DATE,
  SET_NOTE_CREATED_PENDING
} from '../../apollo/actions'
import loSto from '../../config/loSto'
import { Constants } from '@sukiai/components'
import { getFullName } from '@sukiai/utils'
import {
  LO_STO,
  ROUTES,
  sortItemsByKey,
  FETCH_POLICY,
  openProcessingNote,
  NOTE_QUEUE_STATUS,
  getCompBeingCreated,
  setCompBeingCreated
} from '../../lib'
import get from 'lodash/get'
import { getStreamWorker } from '../../ws/stream'
import { DataCommand } from '../../ws/DataCommand'
import queryString from 'query-string'
import FunctionalPatientNotesContainer from './PatientNotesContainer'
const {
  AGENT,
  LISTS,
  DIMENSIONS,
  MODALS,
  NOTE_STATUS
} = Constants
const { LIST_CELL_ONE } = DIMENSIONS
const EMPTY_LIST = (LIST_CELL_ONE * 3) - 2

const getPanelTitle = patient => {
  const name = patient && patient.person && getFullName(patient.person)
  const lastChar = name.substr(name.length - 1, 1)
  return lastChar === 's' ? `${name}' Notes` : `${name}'s Notes`
}

class PatientNotesContainer extends Component {
  state = {
    calcheight: EMPTY_LIST
  }

  componentDidMount () {
    const {
      setAgentPosition,
      setAgentSize,
      match
    } = this.props

    setAgentPosition(AGENT.POSITION.MIDDLE_LEFT)
    setAgentSize(AGENT.SIZE.LARGE)

    loSto.set(LO_STO.CURRENT_PATIENT_ID, get(match, 'params.patientId'))

    const params = queryString.parse(this.props.location.search)

    const noteId = params.note_id

    if (noteId) {
      this.openPatientNote(noteId, true)
    }
  }

  onNoteClick = async (id, status, isPatientNote) => {
    const {
      history,
      client,
      lockNoteForEdit
    } = this.props

    // Check in case of stale note status
    if (
      status &&
      status !== NOTE_STATUS.SUBMITTED_TO_EMR &&
      status !== NOTE_STATUS.IMPORTED_FROM_EMR
    ) {
      const { data } = await client.query({
        query: GetCompositionMetadataById,
        variables: { id },
        fetchPolicy: FETCH_POLICY.NETWORK_ONLY
      })

      status = get(data, 'compositions.results[0].metadata.status')

      if (status === NOTE_STATUS.SUBMITTED_TO_EMR || status === NOTE_STATUS.IMPORTED_FROM_EMR) {
        this.openPatientNote(id, isPatientNote)
      } else if (status === NOTE_STATUS.USER_IS_DONE) {
        // check if note is already being processed by scribe
        const isNoteBeingProcessed = await lockNoteForEdit({
          variables: { noteId: id }
        }).then(({ data }) => {
          const status = get(data, 'lockNoteForEdit.status')
          return status === NOTE_QUEUE_STATUS.NOTE_IS_BEING_EDITED
        })

        if (isNoteBeingProcessed) {
          openProcessingNote(id)
          return
        }
        loSto.set(LO_STO.CURRENT_COMP_ID, id)
        loSto.remove(LO_STO.CURRENT_NOTE_ID)
        history.push(`${ROUTES.NOTE}/${id}`)

        // todo temporary commented modal till same functional will be implemented on other platforms
        // Show a modal indicating that the user needs to hit I'm done, to make sure the note gets processed again
        /*        client.mutate({
          mutation: SET_MODAL,
          variables: {
            content: {
              __typename: 'ModalContent',
              type: MODALS.ERROR,
              heading: 'Review note',
              body: 'You are editing a note already submitted for processing. Please press the "I\'m Done" button again, after reviewing the note.'
            }
          }
        }) */
      } else {
        loSto.set(LO_STO.CURRENT_COMP_ID, id)
        loSto.remove(LO_STO.CURRENT_NOTE_ID)
        history.push(`${ROUTES.NOTE}/${id}`)
      }
    } else {
      this.openPatientNote(id, isPatientNote)
    }
  }

  openPatientNote = (id, isPatientNote) => {
    const {
      setAgentPosition,
      setAgentSize,
      setModal
    } = this.props

    loSto.set(isPatientNote ? LO_STO.CURRENT_NOTE_ID : LO_STO.CURRENT_COMP_ID, id)
    loSto.remove(isPatientNote ? LO_STO.CURRENT_COMP_ID : LO_STO.CURRENT_NOTE_ID)
    setAgentPosition(AGENT.POSITION.LEFT)
    setAgentSize(AGENT.SIZE.LARGE)
    setModal({
      __typename: 'ModalContent',
      type: MODALS.READ_NOTE
    })
  }

  openNoteTypeSelection = async (patientId) => {
    const {
      client
    } = this.props

    if (await getCompBeingCreated()) return
    setCompBeingCreated(true)

    client.mutate({
      mutation: SET_NOTE_CREATED_PENDING,
      variables: {
        isPending: true
      }
    })

    const stream = getStreamWorker()
    stream && stream.postMessage({
      cmd: DataCommand.USER_REQUEST,
      userRequestType: 'CREATE_NOTE',
      userRequestData: {},
      ts: new Date().toISOString()
    })
  }

  componentWillReceiveProps (nextProps) {
    const {
      setAgentPosition,
      setAgentSize
    } = this.props

    if (nextProps.patientData && nextProps.patientData.id) {
      loSto.set(LO_STO.CURRENT_PATIENT_ID, nextProps.patientData.id)
    }

    if (nextProps.patientLoading) {
      setAgentPosition(AGENT.POSITION.MIDDLE_LEFT)
      setAgentSize(AGENT.SIZE.LARGE)
    }

    if (nextProps.notesLoading || nextProps.notesCount === 0) {
      this.setState({ calcheight: EMPTY_LIST })
    } else if (nextProps.notesCount && nextProps.notesCount > 3) {
      this.setState({
        calcheight: (nextProps.notesCount * LIST_CELL_ONE) + (nextProps.notesCount - 1)
      })
    } else {
      this.setState({ calcheight: EMPTY_LIST })
    }

    if (nextProps.notesData && nextProps.notesData !== this.props.notesData) {
      const compositionIds = []
      const patientNoteIds = []
      nextProps.notesData && nextProps.notesData.forEach(note => {
        if (note.noteId) {
          patientNoteIds.push(note.noteId)
        } else if (note.id) {
          compositionIds.push(note.id)
        }
      })
      nextProps.setNotesList(compositionIds, patientNoteIds)
    }
  }

  componentWillUnmount () {
    loSto.remove(LO_STO.CURRENT_PATIENT_ID)
    this.props.setNotesList([], [])
    setCompBeingCreated(false)
  }

  render () {
    const {
      notesLoading,
      notesCount,
      notesData,
      patientData
    } = this.props

    return (
      <FunctionalPatientNotesContainer
        type={LISTS.PATIENT_NOTES}
        title={patientData ? getPanelTitle(patientData) : 'Patient Notes'}
        loading={notesLoading}
        count={notesCount}
        notes={notesData}
        handleClick={this.onNoteClick}
        calcheight={this.state.calcheight}
        openNoteTypeSelection={this.openNoteTypeSelection}
      />
    )
  }
}

const mapNotesToProps = ({ data }) => {
  const allNotes = get(data, 'allNotes.results', [])
  const viewableNotes = allNotes.filter(note => !note.metadata?.partialDictation?.partialDictationComposition)
  return {
    notesError: data.error,
    notesLoading: data.loading,
    notesCount: viewableNotes.length,
    notesData: viewableNotes
  }
}

const mapPatientToProps = ({ data }) => ({
  patientError: data.error,
  patientLoading: data.loading,
  patientData: get(data, 'patients.results[0]')
})

const mapNoteTypesToProps = ({ data }) => ({
  noteTypesError: data.error,
  noteTypesLoading: data.loading,
  noteTypesCount: get(data, 'noteTypes.count', 0),
  noteTypesData: sortItemsByKey(get(data, 'noteTypes.results', []).slice(), 'name')
})

export default compose(
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize => mutate({
        variables: { agentSize }
      })
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition => mutate({
        variables: { agentPosition }
      })
    })
  }),
  graphql(SET_MODAL, {
    props: ({ mutate }) => ({
      setModal: content => mutate({
        variables: { content }
      })
    })
  }),
  graphql(SET_NOTES_LIST, {
    props: ({ mutate }) => ({
      setNotesList: (compositionIds, patientNoteIds) => mutate({
        variables: {
          compositionIds,
          patientNoteIds
        }
      })
    })
  }),
  graphql(GET_SCHEDULE_DATE, {
    props: ({ data: { scheduleDate } }) => ({
      scheduleDate: scheduleDate.date
    })
  }),
  graphql(GetPatientsById, {
    skip: ({ match }) => !get(match, 'params.patientId'),
    options: ({ match }) => ({
      variables: {
        ids: [get(match, 'params.patientId')]
      }
    }),
    props: mapPatientToProps
  }),
  graphql(GetAllNotes, {
    skip: ({ match }) => !get(match, 'params.patientId'),
    options: ({ match }) => ({
      variables: {
        userId: loSto.get(LO_STO.USER_ID),
        patientId: get(match, 'params.patientId')
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }),
    props: mapNotesToProps
  }),
  graphql(GetAllNoteTypes, {
    options: () => ({
      variables: {
        userId: loSto.get(LO_STO.USER_ID)
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }),
    props: mapNoteTypesToProps
  }),
  graphql(CreateComposition, { name: 'createComposition' }),
  graphql(UpdateCompositionStatus, { name: 'updateCompositionStatus' }),
  graphql(LockNoteForEdit, { name: 'lockNoteForEdit' }),
  withRouter,
  withApollo
)(PatientNotesContainer)
